import { render, staticRenderFns } from "./IconInitials.vue?vue&type=template&id=e22587ec&"
import script from "./IconInitials.vue?vue&type=script&lang=js&"
export * from "./IconInitials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports